import { forwardRef } from 'react';
import { Input } from '@/components/ui/input';
import { cn } from '@/utils';

export const MFA_CODE_LENGTH = 6;

interface MfaCodeInputProps {
  value: string;
  onChange: (code: string) => void;
  onComplete?: (code: string) => void;
  readOnly?: boolean;
  autoFocus?: boolean;
  className?: string;
}

// The code stays a string so leading zeros survive.
const MfaCodeInput = forwardRef<HTMLInputElement, MfaCodeInputProps>(
  ({ value, onChange, onComplete, readOnly, autoFocus, className }, ref) => (
    <Input
      ref={ref}
      type="text"
      inputMode="numeric"
      autoComplete="one-time-code"
      maxLength={MFA_CODE_LENGTH}
      placeholder="000000"
      aria-label="Authenticator code"
      value={value}
      readOnly={readOnly}
      autoFocus={autoFocus}
      className={cn('text-center tracking-[0.5em]', className)}
      onChange={(e) => {
        const code = e.target.value.replace(/\D/g, '').slice(0, MFA_CODE_LENGTH);
        onChange(code);
        if (code.length === MFA_CODE_LENGTH && code !== value) onComplete?.(code);
      }}
    />
  )
);
MfaCodeInput.displayName = 'MfaCodeInput';

export default MfaCodeInput;
